<div class="w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>{{ 'label_housing_request' | translate }}</h2>
    </div>
    <span class="separator-line block mb-[px]"></span>
    <br />
    <mat-tab-group
        class="sm:px-2 hjalp-tab-group fade-in-left"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedPanelIndex"
        (selectedTabChange)="tabChanged($event)"
    >
        <mat-tab label="{{ 'label_register_request' | translate }}">
            @if (form) {
                <form [formGroup]="form" #profileInNgForm="ngForm">
                    <div class="grid sm:grid-cols-4 gap-6 w-full">
                        <ng-container>
                            <div class="col-span-4">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_title' | translate }}</mat-label>
                                    <input [formControlName]="'summary'" maxlength="255" matInput />
                                    <mat-hint class="ml-auto"
                                        ><span
                                            class="bold"
                                            [ngClass]="{
                                                'notification-color': this.form?.get('summary')?.value?.length > 190,
                                            }"
                                        >
                                            {{ 255 - this.form?.get('summary')?.value?.length }}
                                        </span>
                                        {{
                                            'info_characters_left'
                                                | translate
                                                    : {
                                                          count: 255 - this.form?.get('summary')?.value?.length,
                                                      }
                                                | lowercase
                                        }}
                                    </mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4">
                                <div
                                    class="text-[14px] font-medium mb-1"
                                    [ngClass]="{
                                        'validation-error-color': form?.get('description')?.hasError('required') && submitted,
                                        'opacity-60': !formEnabled,
                                    }"
                                >
                                    {{ 'label_description' | translate }} *
                                </div>
                                <ckeditor
                                    [disabled]="form?.get('description')?.disabled"
                                    [editor]="descriptionEditor"
                                    [(ngModel)]="descriptionTextHTML"
                                    name="descriptionTextHTML"
                                    [ngModelOptions]="{ standalone: true }"
                                    [config]="editorConfig"
                                    (ready)="onEditorReady($event)"
                                    (change)="descriptionOnChange($event)"
                                    id="editorDescription"
                                ></ckeditor>
                            </div>
                        </ng-container>
                    </div>
                    <div class="flex items-center justify-end mt-[20px]">
                        @if (form.dirty) {
                            <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                                {{ 'label_cancel' | translate }}
                            </button>
                        }
                        <button class="ml-4" (click)="submit()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                            @if (formEnabled) {
                                <span>
                                    {{ 'label_register_request' | translate }}
                                </span>
                            }
                            @if (!formEnabled) {
                                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                            }
                        </button>
                    </div>
                </form>
            }
        </mat-tab>
        <mat-tab [label]="'label_my_request' | translatePlural">
            <div>
                <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData" class="w-[100%]">
                    <ng-container matColumnDef="key">
                        <th mat-sort-header="key" mat-header-cell *matHeaderCellDef>
                            {{ 'label_audkenni' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="c-link" target="_blank" [matTooltip]="'label_open_request' | translate" href="{{ element.url }}">{{
                                element.key
                            }}</a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                            {{ 'label_title' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="c-link" target="_blank" [matTooltip]="'label_open_request' | translate" href="{{ element.url }}">{{
                                element.title
                            }}</a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="created">
                        <th mat-sort-header="created" mat-header-cell *matHeaderCellDef>
                            {{ 'label_date' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span [matTooltip]="'label_registered_at' | translate">{{ formatDate(element.created) }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                            {{ 'label_status' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span
                                class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                                [ngClass]="{
                                    'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': element.status === 'Móttekið',
                                    'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': element.status === 'Hætt við',
                                    'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50':
                                        element.status !== 'Móttekið' &&
                                        element.status !== 'Hætt við' &&
                                        element.status !== 'Lokið' &&
                                        element.status !== 'Leyst',
                                    'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                        element.status === 'Lokið' || element.status === 'Leyst',
                                }"
                            >
                                <span class="leading-relaxed whitespace-nowrap">{{ element.status }}</span>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: orgRequestsColumns"></tr>
                    <tr class="mat-row" [ngClass]="{ 'h-0': isLoading }" *matNoDataRow>
                        @if (!isLoading && initialFetchComplete) {
                            <div class="flex items-center justify-between">
                                <span>
                                    <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                        {{ 'info_requests_found_count' | translate: { count: 0 } }}
                                    </div>
                                </span>
                            </div>
                        }
                    </tr>
                </table>
            </div>
            @if (isLoading) {
                <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                    <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-progress-spinner>
                    Sæki beiðnir
                </div>
            }
            @if (!isLastPage) {
                <div #sentinel class="h-1"></div>
            }
        </mat-tab>
    </mat-tab-group>
</div>
